import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { SEO } from '../components/SEO';
import { Breadcrumb } from '../components/Breadcrumb';
import { BreadcrumbSchema } from '../components/SchemaOrg';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { articles as articlesData } from '../data/articles';

const Blog = () => {
  const articles = Object.values(articlesData);

  const breadcrumbItems = [
    { name: 'Blog', url: '/blog' }
  ];

  return (
    <>
      <SEO
        title="Blog Plomberie - Conseils et Astuces d'Entretien | NHM Plomberie"
        description="Blog plomberie NHM : conseils d'entretien, astuces pratiques, guides pour prévenir fuites et bouchons. Les conseils d'un plombier professionnel à Paris."
        keywords="blog plomberie, entretien canalisations, astuces plomberie, conseils plombier, prévention fuites"
        canonical="https://nhm-plomberie.fr/blog"
      />
      <BreadcrumbSchema items={[{ name: 'Accueil', url: 'https://nhm-plomberie.fr/' }, ...breadcrumbItems.map(item => ({ name: item.name, url: `https://nhm-plomberie.fr${item.url}` }))]} />

      <Breadcrumb items={breadcrumbItems} />

      <section className="bg-blue-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Blog Plomberie NHM</h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            Conseils d'experts, astuces d'entretien et guides pratiques pour prendre soin de votre plomberie au quotidien.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article, index) => (
              <Card key={index} className="hover:shadow-xl transition-all duration-300 border-2 hover:border-blue-600 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover"
                />
                <CardHeader>
                  <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                    <span className="flex items-center gap-1">
                      <Calendar size={16} />
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock size={16} />
                      {article.readTime}
                    </span>
                  </div>
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold mb-3">
                    {article.category}
                  </span>
                  <CardTitle className="text-2xl mb-3">{article.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 mb-6">{article.excerpt}</p>
                  <Button asChild className="w-full">
                    <Link to={`/blog/${article.slug}`} className="flex items-center justify-center gap-2">
                      Lire l'article <ArrowRight size={18} />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;